import classNames from 'classnames';
import PropTypes from 'prop-types';
import Icon from '../Icon/Icon';
import Count from './Count';

const Pager = (props) => {
  const {
    id,
    className,
    style,
    countRight,
    disabled,
    hideCount,
    onNextClick,
    onPrevClick,
    paging: {
      current_page,
      next_page,
      prev_page,
      per,
      total_count,
    },
  } = props;

  const prevBtnLabel = 'Previous Page';
  const nextBtnLabel = 'Next Page';

  const pagerContainerClass = () => classNames("flex items-center", {
    "flex-row-reverse justify-start": countRight,
    "justify-end": !countRight,
  }, className);

  const actionsClass = () => `flex flex-row ${countRight ? 'mr-4' : 'ml-4'}`;

  const nextBtnClass = () => classNames("bg-white border h-9 w-12 outline-none rounded-r pl-2.5 active:bg-field-border",{
    "bg-white cursor-default": !next_page || disabled,
    "hover:bg-medium-fill-blue": next_page && !disabled,
  });

  const prevBtnClass = () => classNames("bg-white border h-9 w-12 outline-none rounded-l mr-[-1px] pr-2.5 active:bg-field-border", {
    "bg-white cursor-default": !prev_page || disabled,
    "hover:bg-medium-fill-blue": prev_page && !disabled,
  });

  return (
    <div
      id={id}
      className={pagerContainerClass()}
      style={style}
    >
      {(!hideCount) &&
        <Count
          currentPage={current_page}
          per={per}
          totalCount={total_count}
      />}

      <div className={actionsClass()}>
        <button
          tabIndex={0}
          className={prevBtnClass()}
          id={id}
          aria-label={prevBtnLabel}
          disabled={!prev_page || disabled}
          onClick={onPrevClick}
          style={style}
        >
          <Icon icon="ChevronArrow" direction="left" size={10} />
          <span className="sr-only">Previous Page</span>
        </button>
        <button
          tabIndex={0}
          className={nextBtnClass()}
          id={id}
          aria-label={nextBtnLabel}
          disabled={!next_page || disabled}
          onClick={onNextClick}
          style={style}
        >
          <Icon icon="ChevronArrow" direction="right" size={10} />
          <span className="sr-only">Next Page</span>
        </button>
      </div>
    </div>
  );
};

Pager.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /** If true, pagination counter is on the right. */
  countRight: PropTypes.bool,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object,
  /** If true, buttons are disabled. */
  disabled: PropTypes.bool.isRequired,
  /** If true, pagination counter is hidden. */
  hideCount: PropTypes.bool,
  /** Callback function when the next button is clicked */
  onNextClick: PropTypes.func.isRequired,
  /** Callback function when the previous button is clicked */
  onPrevClick: PropTypes.func.isRequired,
  /** paging object with paginatin information */
  paging: PropTypes.object.isRequired,
};

Pager.defaultProps = {
  id: '',
  className: '',
  countRight: false,
  disabled: false,
  hideCount: false,
  style: {},
};

export default Pager;
